import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AccessTokenContextProps {
    userAccessToken: string | null;
    setUserAccessToken: (index: string | null) => void;
    updateUserAccessTokenFunction: (index: string) => void;
}

const AccessTokenContext = createContext<AccessTokenContextProps | undefined>(undefined);

export const useAccessToken = (): AccessTokenContextProps => {
  const context = useContext(AccessTokenContext);
  if (!context) {
    throw new Error('error');
  }
  return context;
};

interface AccessTokenProviderProps {
  children: ReactNode;
}

const AccessTokenProvider: React.FC<AccessTokenProviderProps> = ({ children }) => {
  const [userAccessToken, setUserAccessToken] = useState<string | null>(null);

  const updateUserAccessTokenFunction = (index: string | null) => {
    setUserAccessToken(index);
  };

  const contextValue: AccessTokenContextProps = {
    userAccessToken,
    updateUserAccessTokenFunction,
    setUserAccessToken
  };

  return (
    <AccessTokenContext.Provider value={contextValue}>
      {children}
    </AccessTokenContext.Provider>
  );
};

export default AccessTokenProvider
